import {Box, Typography} from "@mui/material";
import {c} from "../landingTokens";
import {Section, Eyebrow} from "./Shell";

const SPECS = [
  ["Languages", "EN, MK, SR, HR — more trainable"],
  ["Response latency", "Under 1 second"],
  ["Concurrent calls", "Elastic, no hard cap"],
  ["Telephony", "SIP trunk → Asterisk"],
  ["Hosting", "EU cloud or on-prem"],
  ["Business systems", "MCP tools + REST"],
  ["Audio transport", "AudioSocket, bidirectional"],
  ["Supervision", "Live monitor, takeover, comments"],
  ["Time to production", "3–6 weeks"],
];

export const Specs = () => (
  <Section id="specs" label="Specs">
    <Eyebrow>Specs</Eyebrow>
    <Typography component="h2" sx={{fontSize: "clamp(30px, 4.2vw, 50px)", lineHeight: 1.05, letterSpacing: "-0.03em", fontWeight: 600, maxWidth: 640, mb: 5.5}}>
      The details, in one place.
    </Typography>

    <Box sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", columnGap: 6}}>
      {SPECS.map(([key, value]) => (
        <Box key={key} sx={{borderTop: `1px solid ${c.lineStrong}`, py: 2.5, display: "flex", justifyContent: "space-between", gap: 2.5}}>
          <Typography sx={{fontSize: 14, color: c.inkSoft}}>{key}</Typography>
          <Typography sx={{fontSize: 14, fontWeight: 500, textAlign: "right"}}>{value}</Typography>
        </Box>
      ))}
    </Box>
  </Section>
);
